<template>
  <div class="frisbuy-guide-popup__overlay" @click.self="() => closePopup()">
    <div class="frisbuy-guide-popup frisbuy-scroller">
      <div class="frisbuy-guide-popup-controls">
        <div
          class="frisbuy-close frisbuy-guide-popup-control frisbuy-askona-popup-control frisbuy-askona-close"
          @click="() => closePopup()"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.6077 6.29462C17.2138 5.90748 16.5807 5.91296 16.1936 6.30685L11.9878 10.586L7.70878 6.38028C7.31489 5.99315 6.68175 5.99862 6.29462 6.39251C5.90748 6.7864 5.91296 7.41954 6.30685 7.80667L10.5859 12.0123L6.38006 16.2916C5.99293 16.6855 5.9984 17.3186 6.39229 17.7058C6.78618 18.0929 7.41932 18.0874 7.80645 17.6935L12.0123 13.4143L16.2916 17.6202C16.6855 18.0073 17.3186 18.0018 17.7058 17.6079C18.0929 17.214 18.0874 16.5809 17.6935 16.1938L13.4142 11.9879L17.6199 7.70878C18.0071 7.31489 18.0016 6.68175 17.6077 6.29462Z"
              fill="#999999"
            />
          </svg>
        </div>
      </div>

      <div class="fb-guideline-block">
        <div class="fb-guideline-header">
          <h1 class="fb-guideline-header__heading">
            Как попасть в галерею на сайте Askona
          </h1>
        </div>
        <div class="fb-guideline-path-publish">
          <div class="fb-guideline-path-publish-block">
            <svg
              class="fb-guideline-path-publish-block-icon"
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.0054 9.8467C12.5994 9.8467 9.85206 12.594 9.85206 16C9.85206 19.406 12.5994 22.1533 16.0054 22.1533C19.4114 22.1533 22.1587 19.406 22.1587 16C22.1587 12.594 19.4114 9.8467                     16.0054 9.8467ZM16.0054 20.0004C13.8043 20.0004 12.0049 18.2064 12.0049 16C12.0049 13.7936 13.799 11.9996 16.0054 11.9996C18.2118 11.9996 20.0058 13.7936 20.0058 16C20.0058 18.2064 18.2064 20.0004 16.0054 20.0004ZM23.8456 9.595C23.8456 10.3929 23.2029 11.0302 22.4104 11.0302C21.6124 11.0302 20.9751 10.3876 20.9751 9.595C20.9751 8.80241 21.6178 8.15977 22.4104 8.15977C23.2029 8.15977 23.8456 8.80241 23.8456 9.595ZM27.921 11.0517C27.83 9.12909 27.3908 7.42609 25.9824 6.02298C24.5793 4.61988 22.8763 4.18074 20.9537 4.08435C18.9722 3.97188 13.0331 3.97188 11.0517 4.08435C9.13444 4.17539 7.43144 4.61453 6.02298 6.01763C4.61453 7.42073 4.18074 9.12373 4.08435 11.0463C3.97188 13.0278 3.97188 18.9669 4.08435 20.9483C4.17539 22.8709 4.61453 24.5739 6.02298 25.977C7.43144 27.3801 9.12909 27.8193 11.0517 27.9157C13.0331 28.0281 18.9722 28.0281 20.9537 27.9157C22.8763 27.8246 24.5793 27.3855 25.9824 25.977C27.3855 24.5739 27.8246 22.8709 27.921 20.9483C28.0335 18.9669 28.0335 13.0331 27.921 11.0517ZM25.3612 23.0744C24.9434 24.1241 24.1348 24.9327 23.0798 25.3558C21.4999 25.9824 17.7512 25.8378 16.0054 25.8378C14.2595 25.8378 10.5054 25.977 8.93094 25.3558C7.88129 24.9381 7.07263 24.1294 6.64956 23.0744C6.02298 21.4946 6.16758 17.7458 6.16758 16C6.16758 14.2542 6.02834 10.5001 6.64956 8.92558C7.06728 7.87593 7.87593 7.06728 8.93094 6.6442C10.5108 6.01763 14.2595 6.16222 16.0054 6.16222C17.7512 6.16222 21.5053 6.02298 23.0798 6.6442C24.1294 7.06192 24.9381 7.87058 25.3612 8.92558C25.9877 10.5054 25.8431 14.2542 25.8431 16C25.8431 17.7458 25.9877 21.4999 25.3612 23.0744Z"
                fill="#212121"
              />
            </svg>
            <div class="fb-guideline-path-publish-block-header">
              Выложите пост в соцсетях
            </div>
            <div class="fb-guideline-path-publish-block-text">
              Добавьте фото/видео с товаром и отметьте @askona_official
              в описании к посту
            </div>
          </div>
          <div class="fb-guideline-path-publish-block">
            <svg
              class="fb-guideline-path-publish-block-icon"
              width="33"
              height="32"
              viewBox="0 0 33 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16.3327 26.6667C10.4415 26.6667 5.66602 21.8912 5.66602 16C5.66602 10.1088 10.4415 5.33334 16.3327 5.33334C22.2239 5.33334 26.9993 10.1088 26.9993 16C26.9993 21.8912 22.2239 26.6667 16.3327 26.6667ZM24.866 16C24.866 13.7368 23.967 11.5663 22.3667 9.96603C20.7663 8.36572 18.5959 7.46668 16.3327 7.46668C14.0695 7.46668 11.899 8.36572 10.2987 9.96603C8.69839 11.5663 7.79935 13.7368 7.79935 16C7.79935 18.2632 8.69839 20.4337 10.2987 22.034C11.899 23.6343 14.0695 24.5333 16.3327 24.5333C18.5959 24.5333 20.7663 23.6343 22.3667 22.034C23.967 20.4337 24.866 18.2632 24.866 16ZM20.5993 14.9333C20.8822 14.9333 21.1536 15.0457 21.3536 15.2458C21.5536 15.4458 21.666 15.7171 21.666 16C21.666 16.2829 21.5536 16.5542 21.3536 16.7543C21.1536 16.9543 20.8822 17.0667 20.5993 17.0667H17.3993C16.226 17.0667 15.266 16.1067 15.266 14.9333V10.6667C15.266 10.3838 15.3784 10.1125 15.5784 9.91243C15.7785 9.71239 16.0498 9.60001 16.3327 9.60001C16.6156 9.60001 16.8869 9.71239 17.0869 9.91243C17.287 10.1125 17.3993 10.3838 17.3993 10.6667V14.9333H20.5993Z"
                fill="#212121"
              />
            </svg>
            <div class="fb-guideline-path-publish-block-header">
              Дождитесь модерации
            </div>
            <div class="fb-guideline-path-publish-block-text">
              Если пост прошел модерацию, вы получите комментарий к посту.
              Просто ответьте на него хештегом #yesaskona
            </div>
          </div>
          <div class="fb-guideline-path-publish-block">
            <svg
              class="fb-guideline-path-publish-block-icon"
              width="33"
              height="32"
              viewBox="0 0 33 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.6667 5.33334C10.8 5.33334 6 10.1333 6 16C6 21.8667 10.8 26.6667 16.6667 26.6667C22.5333 26.6667 27.3333 21.8667 27.3333 16C27.3333 10.1333 22.5333 5.33334 16.6667 5.33334ZM16.6667 24.4C12 24.4 8.26667 20.6667 8.26667 16C8.26667 11.3333 12 7.60001 16.6667 7.60001C21.3333 7.60001 25.0667 11.3333 25.0667 16C25.0667 20.6667 21.3333 24.4 16.6667 24.4Z"
                fill="#212121"
              />
              <path
                d="M20.1333 12.9333L15.4667 17.6L13.2 15.3333C12.8 14.9333 12.1625 14.7709 11.6 15.3333C11.2 15.7333 11.2 16.4 11.6 16.9333L14.6667 20C14.9333 20.2667 15.2333 20.3386 15.5 20.3386C15.7667 20.3386 16.0845 20.2016 16.2178 20.0682L21.5511 14.7349C21.9511 14.3349 22.2437 13.6593 21.7783 13.0259C21.2955 12.478 20.5333 12.5333 20.1333 12.9333Z"
                fill="#212121"
              />
            </svg>
            <div class="fb-guideline-path-publish-block-header">Готово!</div>
            <div class="fb-guideline-path-publish-block-text">
              После подтверждения ваш пост автоматически появится на сайте
              в нашей галерее
            </div>
          </div>
        </div>

        <div class="fb-guideline-path-publish-block-approve-tips">
          <div class="fb-guideline-path-publish-header">
            Что важно учесть перед публикацией
          </div>
          <div class="fb-guideline-path-publish-block-approve-tip">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="9" fill="#00B9BF" />
              <path
                d="M16.4863 10.7071C16.8768 10.3166 16.8768 9.68342 16.4863 9.29289C16.0957 8.90237 15.4626 8.90237 15.072 9.29289L10.8289 13.536L8.70711 11.4143C8.31658 11.0237 7.68342 11.0237 7.29289 11.4143C6.90237 11.8048 6.90237 12.4379 7.29289 12.8285L10.1213 15.6569C10.3297 15.8653 10.6071 15.9624 10.8799 15.9485C11.1187 15.9365 11.3541 15.8393 11.5365 15.6569L16.4863 10.7071Z"
                fill="white"
              />
            </svg>
            <span class="fb-guideline-path-publish-block-approve-text"
              >Только качественные фото и видео (без пикселей, размытия,
              темноты)</span
            >
          </div>
          <div class="fb-guideline-path-publish-block-approve-tip">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="9" fill="#00B9BF" />
              <path
                d="M16.4863 10.7071C16.8768 10.3166 16.8768 9.68342 16.4863 9.29289C16.0957 8.90237 15.4626 8.90237 15.072 9.29289L10.8289 13.536L8.70711 11.4143C8.31658 11.0237 7.68342 11.0237 7.29289 11.4143C6.90237 11.8048 6.90237 12.4379 7.29289 12.8285L10.1213 15.6569C10.3297 15.8653 10.6071 15.9624 10.8799 15.9485C11.1187 15.9365 11.3541 15.8393 11.5365 15.6569L16.4863 10.7071Z"
                fill="white"
              />
            </svg>
            <span class="fb-guideline-path-publish-block-approve-text"
              >На кадре — сам товар или его применение</span
            >
          </div>
          <div class="fb-guideline-path-publish-block-approve-examples">
            <div class="fb-guideline-path-publish-block-approve-example-img">
              <img
                class="fb-guideline-path-publish-block-approve-example"
                :src="getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102169/1022_asset_askona-photo-guide-1-1_1751961226.jpg')"
                @error="errorImageHandler"
              />
            </div>
            <div class="fb-guideline-path-publish-block-approve-example-img">
              <img
                class="fb-guideline-path-publish-block-approve-example"
                :src="getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102145/1022_asset_askona-photo-guide-1-2_1751961299.jpg')"
                @error="errorImageHandler"
              />
            </div>
            <div class="fb-guideline-path-publish-block-approve-example-img">
              <img
                class="fb-guideline-path-publish-block-approve-example"
                :src="getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102185/1022_asset_askona-photo-guide-1-3_1751961315.jpg')"
                @error="errorImageHandler"
              />
            </div>
            <div
              class="fb-guideline-path-publish-block-approve-example-img mobile"
            >
              <img
                class="fb-guideline-path-publish-block-approve-example"
                :src="getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102156/1022_asset_askona-photo-guide-1-4_1751963493.jpg')"
                @error="errorImageHandler"
              />
            </div>
          </div>
        </div>

        <div class="fb-guideline-path-publish-block-approve-tips negative">
          <div class="fb-guideline-path-publish-block-approve-tip negative">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.1932 6.30634C16.5804 5.91246 17.2134 5.90749 17.6073 6.29462C18.0012 6.68175 18.0071 7.3148 17.62 7.70868L13.4139 11.987L17.6932 16.1931C18.0871 16.5802 18.0931 17.2142 17.7059 17.6081C17.3189 18.0018 16.6858 18.0067 16.2919 17.6198L12.0116 13.4138L7.80653 17.6931C7.41949 18.0868 6.78637 18.0926 6.39247 17.7058C5.99867 17.3187 5.99292 16.6856 6.37977 16.2917L10.5848 12.0114L6.30653 7.80634C5.91276 7.4192 5.90772 6.78612 6.29481 6.39228C6.68192 5.99854 7.31502 5.99258 7.70887 6.37958L11.9872 10.5847L16.1932 6.30634Z"
                fill="#FE0066"
              />
            </svg>
            <span class="fb-guideline-path-publish-block-approve-text"
              >Не размещайте фото с посторонними предметами и перегруженным
              фоном</span
            >
          </div>
          <div class="fb-guideline-path-publish-block-approve-tip negative">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.1932 6.30634C16.5804 5.91246 17.2134 5.90749 17.6073 6.29462C18.0012 6.68175 18.0071 7.3148 17.62 7.70868L13.4139 11.987L17.6932 16.1931C18.0871 16.5802 18.0931 17.2142 17.7059 17.6081C17.3189 18.0018 16.6858 18.0067 16.2919 17.6198L12.0116 13.4138L7.80653 17.6931C7.41949 18.0868 6.78637 18.0926 6.39247 17.7058C5.99867 17.3187 5.99292 16.6856 6.37977 16.2917L10.5848 12.0114L6.30653 7.80634C5.91276 7.4192 5.90772 6.78612 6.29481 6.39228C6.68192 5.99854 7.31502 5.99258 7.70887 6.37958L11.9872 10.5847L16.1932 6.30634Z"
                fill="#FE0066"
              />
            </svg>
            <span class="fb-guideline-path-publish-block-approve-text"
              >Темные, нечеткие, смазанные снимки не подойдут</span
            >
          </div>
          <div class="fb-guideline-path-publish-block-approve-examples">
            <div
              class="fb-guideline-path-publish-block-approve-example-img negative"
            >
              <img
                class="fb-guideline-path-publish-block-approve-example"
                :src="getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102160/1022_asset_askona-photo-guide-2-1_1751966497.jpg')"
                @error="errorImageHandler"
              />
            </div>
            <div
              class="fb-guideline-path-publish-block-approve-example-img negative"
            >
              <img
                class="fb-guideline-path-publish-block-approve-example"
                :src="getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102167/1022_asset_askona-photo-guide-2-2_1751966513.jpg')"
                @error="errorImageHandler"
              />
            </div>
            <div
              class="fb-guideline-path-publish-block-approve-example-img negative"
            >
              <img
                class="fb-guideline-path-publish-block-approve-example"
                :src="getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102182/1022_asset_askona-photo-guide-2-3_1751966527.jpg')"
                @error="errorImageHandler"
              />
            </div>
            <div
              class="fb-guideline-path-publish-block-approve-example-img negative mobile"
            >
              <img
                class="fb-guideline-path-publish-block-approve-example"
                :src="getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102146/1022_asset_askona-photo-guide-2-4_1751966555.jpg')"
                @error="errorImageHandler"
              />
            </div>
          </div>

          <div class="fb-guideline-header">
            <h1 class="fb-guideline-header__heading">Как снять хороший кадр</h1>
          </div>
          <div class="fb-guideline-path-publish-block-steps">
            <div class="fb-guideline-path-publish-block-header steps">
              Шаг 1 — Кадр
            </div>
            <div class="fb-guideline-path-publish-block-header steps-text">
              Разместите товар крупно в кадре. Он должен быть хорошо виден и
              узнаваем
            </div>
            <div class="fb-guideline-path-publish-block-steps-examples">
              <div class="fb-guideline-path-publish-block-steps-example-img">
                <img
                  class="fb-guideline-path-publish-block-steps-example"
                  :src="getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102183/1022_asset_askona-photo-guide-3-1_1751968071.jpg')"
                  @error="errorImageHandler"
                />
              </div>
              <div class="fb-guideline-path-publish-block-steps-example-img">
                <img
                  class="fb-guideline-path-publish-block-steps-example"
                  :src="getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102147/1022_asset_askona-photo-guide-3-2_1751968085.jpg')"
                  @error="errorImageHandler"
                />
              </div>
              <div class="fb-guideline-path-publish-block-steps-example-img">
                <img
                  class="fb-guideline-path-publish-block-steps-example"
                  :src="getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102168/1022_asset_askona-photo-guide-3-3_1751968099.jpg')"
                  @error="errorImageHandler"
                />
              </div>
              <div
                class="fb-guideline-path-publish-block-steps-example-img mobile"
              >
                <img
                  class="fb-guideline-path-publish-block-steps-example"
                  :src="getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102158/1022_asset_askona-photo-guide-3-4_1751968116.jpg')"
                  @error="errorImageHandler"
                />
              </div>
            </div>

            <div class="fb-guideline-path-publish-block-header steps">
              Шаг 2 — Свет
            </div>
            <div class="fb-guideline-path-publish-block-header steps-text">
              Освещение — ключ к хорошему фото. Снимайте при дневном свете или
              используйте лампу с мягким светом. Избегайте темных и засвеченных
              кадров
            </div>
            <div class="fb-guideline-path-publish-block-steps-examples">
              <div class="fb-guideline-path-publish-block-steps-example-img">
                <img
                  class="fb-guideline-path-publish-block-steps-example"
                  :src="getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102156/1022_asset_askona-photo-guide-4-1_1751977963.jpg')"
                  @error="errorImageHandler"
                />
              </div>
              <div class="fb-guideline-path-publish-block-steps-example-img">
                <img
                  class="fb-guideline-path-publish-block-steps-example"
                  :src="getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102174/1022_asset_askona-photo-guide-4-2_1751977982.jpg')"
                  @error="errorImageHandler"
                />
              </div>
              <div class="fb-guideline-path-publish-block-steps-example-img">
                <img
                  class="fb-guideline-path-publish-block-steps-example"
                  :src="getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102161/1022_asset_askona-photo-guide-4-3_1751977997.jpg')"
                  @error="errorImageHandler"
                />
              </div>
              <div
                class="fb-guideline-path-publish-block-steps-example-img mobile"
              >
                <img
                  class="fb-guideline-path-publish-block-steps-example"
                  :src="getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102158/1022_asset_askona-photo-guide-4-4_1751978014.jpg')"
                  @error="errorImageHandler"
                />
              </div>
            </div>

            <div class="fb-guideline-path-publish-block-header steps">
              Шаг 3 — Фон
            </div>
            <div class="fb-guideline-path-publish-block-header steps-text">
              Освободите фон от посторонних предметов. Публикации с
              перегруженным фоном с большой вероятностью не пройдут проверку
            </div>
            <div class="fb-guideline-path-publish-block-steps-examples">
              <div class="fb-guideline-path-publish-block-steps-example-img">
                <img
                  class="fb-guideline-path-publish-block-steps-example"
                  :src="getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102165/1022_asset_askona-photo-guide-5-1_1751978118.jpg')"
                  @error="errorImageHandler"
                />
              </div>
              <div class="fb-guideline-path-publish-block-steps-example-img">
                <img
                  class="fb-guideline-path-publish-block-steps-example"
                  :src="getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102182/1022_asset_askona-photo-guide-5-2_1751978130.jpg')"
                  @error="errorImageHandler"
                />
              </div>
              <div class="fb-guideline-path-publish-block-steps-example-img">
                <img
                  class="fb-guideline-path-publish-block-steps-example"
                  :src="getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102152/1022_asset_askona-photo-guide-5-3_1751978144.jpg')"
                  @error="errorImageHandler"
                />
              </div>
              <div
                class="fb-guideline-path-publish-block-steps-example-img mobile"
              >
                <img
                  class="fb-guideline-path-publish-block-steps-example"
                  :src="getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102140/1022_asset_askona-photo-guide-5-4_1751978155.jpg')"
                  @error="errorImageHandler"
                />
              </div>
            </div>
          </div>

          <div class="fb-guideline-path-publish-block-frame">
            <div class="fb-guideline-path-publish-block-frame-texts">
              <div class="fb-guideline-path-publish-block-frame-header">
                Делитесь своим вдохновением и идеями!
              </div>
              <div class="fb-guideline-path-publish-block-frame-text">
                Мы ценим каждый отзыв и с радостью размещаем лучшие кадры на
                сайте.
                <svg 
                  class="fb-guideline-path-publish-block-frame-icon mobile"
                  width="56"
                  height="56"
                  viewBox="0 0 56 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path 
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M42.7841 3.07627C44.5342 2.85819 46.1666 4.04896 46.4763 5.80539L47.189 9.84742H48.5429L47.7893 5.57385C47.3558 3.11502 45.0708 1.44746 42.6208 1.7525L42.3832 1.78844L3.85709 8.58164C1.31892 9.02918 -0.375871 11.4496 0.0716773 13.9878L5.52321 44.9049V37.2266L1.38475 13.7562C1.06508 11.9433 2.27564 10.2144 4.08862 9.89471L42.6147 3.10152L42.7841 3.07627Z"
                    fill="#212121"
                    fill-opacity="0.4"
                  />
                  <path
                    d="M54.6663 16.6264C54.6663 14.8429 53.2656 13.3867 51.5042 13.2976L51.333 13.2931H12.2126C10.3716 13.2931 8.87923 14.7854 8.87923 16.6264V49.4643C8.87932 51.3051 10.3717 52.7976 12.2126 52.7976H51.333C53.1739 52.7976 54.6663 51.3051 54.6663 49.4643V16.6264ZM55.9997 49.4643C55.9996 52.0415 53.9103 54.1309 51.333 54.1309H12.2126C9.63529 54.1309 7.54599 52.0415 7.5459 49.4643V16.6264C7.5459 14.0491 9.63524 11.9597 12.2126 11.9597H51.333L51.5732 11.9656C54.0389 12.0906 55.9997 14.1296 55.9997 16.6264V49.4643Z"
                    fill="#212121"
                    fill-opacity="0.4"
                  />
                  <path
                    d="M11.1865 50.3318V37.1683L22.2064 27.6271C23.0339 26.9515 24.2496 27.0615 24.9425 27.8746L33.5994 37.2516L39.9617 32.9872C40.6692 32.5129 41.5777 32.4575 42.3377 32.8423L52.3584 37.9159V50.3318H11.1865Z"
                    fill="#212121"
                    fill-opacity="0.4"
                  />
                  <circle
                    cx="42.33"
                    cy="23.59"
                    r="3.59462"
                    fill="#212121"
                    fill-opacity="0.4"
                  />
                </svg>
              </div>
            </div>
            <svg
              class="fb-guideline-path-publish-block-frame-icon desktop"
              width="84"
              height="84"
              viewBox="0 0 84 84"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M64.1762 4.61453C66.8014 4.2874 69.2498 6.07356 69.7144 8.7082L70.7835 14.7713H72.8143L71.684 8.3609C71.0337 4.67266 67.6061 2.17131 63.9312 2.62887L63.5748 2.68279L5.78563 12.8726C1.97837 13.5439 -0.563806 17.1745 0.107516 20.9818L8.28481 67.3575V55.84L2.07713 20.6345C1.59762 17.915 3.41346 15.3217 6.13293 14.8422L63.9221 4.6524L64.1762 4.61453Z"
                fill="#212121"
                fill-opacity="0.4"
              />
              <path
                d="M82 24.9397C82 22.2644 79.8989 20.0802 77.2568 19.9465L77 19.9397H18.3193C15.5579 19.9397 13.3193 22.1783 13.3193 24.9397V74.1965C13.3195 76.9578 15.558 79.1965 18.3193 79.1965H77C79.7613 79.1965 81.9999 76.9578 82 74.1965V24.9397ZM84 74.1965C83.9999 78.0624 80.8659 81.1965 77 81.1965H18.3193C14.4534 81.1965 11.3195 78.0624 11.3193 74.1965V24.9397C11.3193 21.0737 14.4533 17.9397 18.3193 17.9397H77L77.3604 17.9485C81.0589 18.136 84 21.1946 84 24.9397V74.1965Z"
                fill="#212121"
                fill-opacity="0.4"
              />
              <path
                d="M16.7803 75.4976V55.7524L33.3101 41.4407C34.5513 40.4273 36.3749 40.5922 37.4142 41.8119L50.3996 55.8775L59.943 49.4808C61.0044 48.7694 62.3671 48.6863 63.507 49.2635L78.5381 56.8739V75.4976H16.7803Z"
                fill="#212121"
                fill-opacity="0.4"
              />
              <circle
                cx="63.4954"
                cy="35.3849"
                r="5.39193"
                fill="#212121"
                fill-opacity="0.4"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// Modules
import { onMounted } from "vue";
// Services
import { MediaCatcher } from "@/common/services/ErrorHandler/ErrorCatcher";
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
// Consts
import widgetTypes from "@/common/consts/widgetTypes";

const emit = defineEmits(["close"]);

const props = defineProps<{
  settings: any;
}>();

onMounted(() => {
  lockWindowScroll();
});

function closePopup() {
  unlockWindowScroll();

  emit("close");
}

function lockWindowScroll() {
  const customScrollElement = props.settings.scrollElement;
  if (customScrollElement) {
    document.querySelector(customScrollElement).style.overflow = "hidden";
  } else {
    document.body.style.overflow = "hidden";
  }
}

function unlockWindowScroll() {
  const customScrollElement = props.settings.scrollElement;
  if (customScrollElement) {
    document.querySelector(customScrollElement).style.overflow = "";
  } else {
    document.body.style.overflow = "";
  }
}

function getDomainSubstitute(srcUrl: string): string {
  return DomainSubstitute(srcUrl);
}

function errorImageHandler(e: Event) {
  MediaCatcher(e, 2, widgetTypes.GALLERY);
}
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}

.frisbuy-guide-popup__overlay {
  display: block;
  position: fixed;

  justify-content: center;
  align-items: center;
  overflow: auto;

  inset: 0;

  min-width: 100vw;
  min-height: 100vh;

  background-color: rgba(0, 0, 0, 0.65);

  animation: show 0.2s linear;

  z-index: 99999999999999;

  * {
    touch-action: manipulation;
  }
}

.frisbuy-guide-popup {
  position: relative;

  width: 100%;
  height: fit-content;
  max-width: 1070px;

  line-height: 1.3;

  background-color: #fff;

  padding: 40px;

  .frisbuy-guide-popup-controls {
    position: absolute;
    top: 0;
    right: 0;

    svg {
      stroke: #fff;
      width: 100%;
      height: 100%;
    }

    .frisbuy-guide-popup-control {
      width: 60px;
      height: 43px;
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: background-color 0.2s linear;
      cursor: pointer;

      &.frisbuy-askona-close {
        width: 40px;
        height: 40px;
        position: absolute;
        top: 0;
        right: 0;

        path {
          fill: #999;
        }

        &:hover {
          path {
            fill: #212121;
          }
        }

        & > svg {
          display: block;
          position: relative;

          width: 24px;
          height: 24px;
          cursor: pointer;
        }
      }
    }

    .frisbuy-guide-popup-navigation {
      .frisbuy-guide-popup-control {
        position: absolute;
        background-color: rgba(0, 0, 0, 0.24);
        height: 100vh;

        &:hover {
          background-color: rgba(0, 0, 0, 0.5);
        }

        svg {
          width: 24px;
        }
      }
    }
  }
}
</style>

<!-- NOTE: styles from sonata by Mantas for fb-guideline-block -->
<style>
.iu-widget__overlay .frisbuy-guideline::-webkit-scrollbar {
  width: 0;
  height: 0;
}

body {
  margin: 0;
}
.frisbuy-guideline {
  color: #212121;
}

.fb-guideline-container {
  margin-bottom: 40px;
  height: max-content;
}

.iu-widget__overlay ::-webkit-scrollbar-thumb {
  background: transparent;
}

.fb-guideline-container svg.fb-guideline-btn-close {
  width: 12px;
  height: 12px;
}

.fb-guideline-container svg.fb-guideline-btn-close circle {
  display: none;
}

.fb-guideline-container svg.fb-guideline-btn-close path {
  d: path(
    "M11.6077 0.294402C11.2138 -0.0927293 10.5807 -0.0872525 10.1936 0.306635L5.98785 4.58574L1.70878 0.380064C1.31489 -0.00706759 0.681748 -0.00159085 0.294616 0.392297C-0.0925156 0.786184 -0.0870389 1.41933 0.306849 1.80646L4.58592 6.01213L0.380059 10.2914C-0.00707299 10.6853 -0.00159624 11.3184 0.392291 11.7055C0.786179 12.0927 1.41932 12.0872 1.80645 11.6933L6.01231 7.41406L10.2916 11.62C10.6855 12.0071 11.3186 12.0016 11.7058 11.6077C12.0929 11.2138 12.0874 10.5807 11.6935 10.1936L7.41424 5.98767L11.6199 1.70856C12.0071 1.31468 12.0016 0.681534 11.6077 0.294402Z"
  );
  fill: #999;
  transform: scale(4);
}

.fb-guideline-header__heading {
  text-align: left;
  font-family: "Gilroy-black";
  font-style: normal;
  line-height: 36px;

  margin: 0;
}

.fb-guideline-path-publish-block-approve-example,
.fb-guideline-path-publish-block-steps-example {
  width: 100%;
}

@media screen and (max-width: 1023px) {
  .fb-guideline-block {
    margin-top: 26px;
  }

  .fb-guideline-header__heading {
    font-size: 24px;
    margin-bottom: 16px;
  }
  .fb-guideline-container {
    padding: 16px 16px 48px;
  }
  .frisbuy-guideline:before {
    content: "";
    display: flex;
    width: 100%;
    background: #fff;
    position: fixed;
    height: 40px;
    z-index: 10;
  }
  .fb-guideline-btn-close {
    position: fixed;
    top: 1.5%;
    right: -3.5%;
    z-index: 11;
  }

  .fb-guideline-path-publish,
  .fb-guideline-path-publish-block-approve-examples {
    margin-bottom: 32px;
  }

  .fb-guideline-path-publish-block {
    padding: 16px;
  }
  .fb-guideline-path-publish-block-header {
    margin-bottom: 4px;
  }
  .fb-guideline-path-publish-block-icon {
    position: absolute;
    width: 24px;
    height: 24px;
  }
  .fb-guideline-path-publish-block-header:not(
      .fb-guideline-path-publish-block-header.steps,
      .fb-guideline-path-publish-block-header.steps-text
    ),
  .fb-guideline-path-publish-block-text {
    padding-left: 35px;
  }
  .fb-guideline-path-publish-block-approve-examples,
  .fb-guideline-path-publish-block-steps-examples {
    flex-wrap: wrap;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  .fb-guideline-path-publish-block-approve-tip {
    align-items: flex-start;
  }
  .fb-guideline-path-publish-block-frame-header {
    font-size: 24px;
  }
  .fb-guideline-path-publish-block-frame-text {
    font-size: 14px;
  }
  .fb-guideline-path-publish-block-frame {
    padding: 16px 20px;
  }
}

@media screen and (min-width: 1024px) {
  .frisbuy-guide-popup {
    max-width: 920px;
    display: flex;
    border-radius: 8px;
    margin: 48px auto;
  }
  .fb-guideline-container {
    padding: 40px;
  }
  .fb-guideline-header__heading {
    font-size: 28px;
    margin-bottom: 24px;
  }
  .fb-guideline-btn-close {
    position: absolute;
    right: -4%;
    top: 1.5%;
  }

  .fb-guideline-path-publish {
    grid-template-columns: repeat(3, minmax(0px, 1fr));
    margin-bottom: 48px;
  }
  .fb-guideline-path-publish-block {
    padding: 24px;
  }
  .fb-guideline-path-publish-block-header {
    margin-bottom: 8px;
  }
  .fb-guideline-path-publish-block-approve-examples,
  .fb-guideline-path-publish-block-steps-examples {
    display: flex;
    margin-bottom: 40px;
  }
  .fb-guideline-path-publish-block-approve-example-img.mobile,
  .fb-guideline-path-publish-block-steps-example-img.mobile {
    display: none;
  }
  .fb-guideline-path-publish-block-approve-example,
  .fb-guideline-path-publish-block-steps-example {
    max-width: 275px;
    max-height: 275px;
  }
  .fb-guideline-path-publish-block-frame-header {
    font-size: 28px;
  }
  .fb-guideline-path-publish-block-frame-text {
    font-size: 16px;
  }
  .fb-guideline-path-publish-block-frame {
    padding: 24px 32px;
  }
  .fb-guideline-path-publish-block-frame-icon.mobile {
    display: none;
  }
}

.fb-guideline-path-publish {
  display: grid;
  column-gap: 16px;
  row-gap: 8px;
}

.fb-guideline-path-publish-block {
  border-radius: 8px;
  background-color: #f6f6f6;
  text-align: left;
  color: #212121;
}

.fb-guideline-path-publish-block-header {
  font-size: 16px;
  font-family: "Gilroy-black";
}

.fb-guideline-path-publish-block-text {
  font-size: 14px;
  font-family: "Gilroy-regular";
}

.fb-guideline-path-publish-header {
  font-size: 20px;
  font-family: "Gilroy-black";
  margin-bottom: 12px;
}

.fb-guideline-path-publish-block-approve-tip {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 12px;
}

.fb-guideline-path-publish-block-approve-examples,
.fb-guideline-path-publish-block-steps-examples {
  gap: 8px;
}

.fb-guideline-path-publish-block-approve-example,
.fb-guideline-path-publish-block-steps-example {
  border-radius: 8px;
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .fb-guideline-path-publish-block-approve-example,
  .fb-guideline-path-publish-block-steps-example {
    max-width: 491px;
    max-height: 491px;
  }
  .fb-guideline-path-publish-block-frame-icon.desktop {
    display: none;
  }
}

@media screen and (min-width: 414px) and (max-width: 767px) {
  /*.fb-guideline-path-publish-block-approve-example, .fb-guideline-path-publish-block-steps-example {
max-width:187px;
max-height:187px;
}*/
  .fb-guideline-path-publish-block-frame-icon.desktop {
    display: none;
  }
}
@media screen and (min-width: 360px) and (max-width: 413px) {
  /*.fb-guideline-path-publish-block-approve-example, .fb-guideline-path-publish-block-steps-example {
max-width:160px;
max-height:160px;
}*/
  .fb-guideline-path-publish-block-frame-icon.desktop {
    display: none;
  }
}
@media screen and (max-width: 359px) {
  /*.fb-guideline-path-publish-block-approve-example, .fb-guideline-path-publish-block-steps-example {
max-width:140px;
max-height:140px;
}*/
  .fb-guideline-path-publish-block-frame-icon.mobile {
    display: none;
  }
}

.fb-guideline-path-publish-block-approve-example-img,
.fb-guideline-path-publish-block-steps-example-img {
  position: relative;
}

.fb-guideline-path-publish-block-approve-text {
  margin-left: 8px;
  width: fit-content;
}

.fb-guideline-path-publish-block-steps-examples {
  margin-bottom: 40px;
}

.fb-guideline-path-publish-block-approve-example-img::before {
  content: " ";
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  position: absolute;
  bottom: auto;
  top: 10px;
  right: 10px;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iOSIgZmlsbD0iIzAwQjlCRiIvPgo8cGF0aCBkPSJNMTYuNDg2MyAxMC43MDcxQzE2Ljg3NjggMTAuMzE2NiAxNi44NzY4IDkuNjgzNDIgMTYuNDg2MyA5LjI5Mjg5QzE2LjA5NTcgOC45MDIzNyAxNS40NjI2IDguOTAyMzcgMTUuMDcyIDkuMjkyODlMMTAuODI4OSAxMy41MzZMOC43MDcxMSAxMS40MTQzQzguMzE2NTggMTEuMDIzNyA3LjY4MzQyIDExLjAyMzcgNy4yOTI4OSAxMS40MTQzQzYuOTAyMzcgMTEuODA0OCA2LjkwMjM3IDEyLjQzNzkgNy4yOTI4OSAxMi44Mjg1TDEwLjEyMTMgMTUuNjU2OUMxMC4zMjk3IDE1Ljg2NTMgMTAuNjA3MSAxNS45NjI0IDEwLjg3OTkgMTUuOTQ4NUMxMS4xMTg3IDE1LjkzNjUgMTEuMzU0MSAxNS44MzkzIDExLjUzNjUgMTUuNjU2OUwxNi40ODYzIDEwLjcwNzFaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K");
  background-color: #00b9bf;
  border-radius: 50%;
}

.fb-guideline-path-publish-block-approve-example-img.negative::before {
  content: " ";
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  position: absolute;
  bottom: auto;
  top: 10px;
  right: 10px;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjE5MzIgNi4zMDYzNEMxNi41ODA0IDUuOTEyNDYgMTcuMjEzNCA1LjkwNzQ5IDE3LjYwNzMgNi4yOTQ2MkMxOC4wMDEyIDYuNjgxNzUgMTguMDA3MSA3LjMxNDggMTcuNjIgNy43MDg2OEwxMy40MTM5IDExLjk4N0wxNy42OTMyIDE2LjE5MzFDMTguMDg3MSAxNi41ODAyIDE4LjA5MzEgMTcuMjE0MiAxNy43MDU5IDE3LjYwODFDMTcuMzE4OSAxOC4wMDE4IDE2LjY4NTggMTguMDA2NyAxNi4yOTE5IDE3LjYxOThMMTIuMDExNiAxMy40MTM4TDcuODA2NTMgMTcuNjkzMUM3LjQxOTQ5IDE4LjA4NjggNi43ODYzNyAxOC4wOTI2IDYuMzkyNDcgMTcuNzA1OEM1Ljk5ODY3IDE3LjMxODcgNS45OTI5MiAxNi42ODU2IDYuMzc5NzcgMTYuMjkxN0wxMC41ODQ4IDEyLjAxMTRMNi4zMDY1MyA3LjgwNjM0QzUuOTEyNzYgNy40MTkyIDUuOTA3NzIgNi43ODYxMiA2LjI5NDgxIDYuMzkyMjhDNi42ODE5MiA1Ljk5ODU0IDcuMzE1MDIgNS45OTI1OCA3LjcwODg3IDYuMzc5NThMMTEuOTg3MiAxMC41ODQ3TDE2LjE5MzIgNi4zMDYzNFoiIGZpbGw9IiNGRTAwNjYiLz4KPC9zdmc+Cg==");
  background-color: #fff;
  border-radius: 50%;
}

.fb-guideline-path-publish-block-header.steps-text {
  margin-bottom: 16px;
}

.fb-guideline-path-publish-block-frame {
  border-radius: 8px;
  background-color: #f6f6f6;
}
.fb-guideline-path-publish-block-frame-texts {
  display: flex;
  flex-direction: column;
}
.fb-guideline-path-publish-block-frame-header {
  margin-bottom: 8px;
}
.fb-guideline-path-publish-block-frame {
  display: flex;
  justify-content: space-between;
}
</style>
